'use strict' ;

function SplitterRequestTransformer(Util,  serviceResponseRepository, jsonMapper, publicIDTransformer, coverTypeTransformer) {

	function getQuoteResponseValue(qouteResponse, pathString) {
		return Util.findHierarchyStringInObject(qouteResponse, pathString, '.') ;
	}

	function transform(quotePermutations, quoteRequest) {
		var quoteResponses = serviceResponseRepository.getLastResponseFrom('quickQuote') ;
		var transformedRequest = null ;
		if ( quoteResponses )
			transformedRequest = transformExistingQuote(quotePermutations, quoteResponses, quoteRequest) ;
		else
			transformedRequest = transformNewQuote(quotePermutations, quoteRequest) ;

		return transformedRequest ;
	}

	function transformExistingQuote(quotePermutations, quoteResponses, quoteRequest) {
		var quotes = Util.generatePermutationsArray(quotePermutations.coverTypes, quotePermutations.paymentFrequencies).map(function(permutation, index) {
			var quote = Object.extend(permutation, quoteRequest);

			var coverType = permutation.option1;
			var paymentFrequency = permutation.option2 ; 
			delete quote.option1; delete quote.option2 ; 
			
			var quoteType = quotePermutations.quoteType ;
			var q = Util.deepClone(quote) ;
			q = Object.extend(q,{
				quoteType: quoteType,
				paymentFrequency: paymentFrequency,
			}) ;

			var quoteResponseBody = null ;
			// var matchingQuoteResponse = findMatchingQuoteResponse(quoteResponses, coverType) ;
			// if ( matchingQuoteResponse )
			// 	quoteResponseBody = matchingQuoteResponse.response;
			q = publicIDTransformer.transform(q, null) ;
			q = coverTypeTransformer.transform(q, coverType.descriptor);
			return q ;
		}) ;

		return quotes.filter(function(quote) { return quote !== null }) ;
	}

	function findMatchingQuoteResponse(quoteResponses, coverType){
		if ( ! quoteResponses )
			return;

		var matchingResponse = null ;
		quoteResponses.some(function(qr) {
			if (qr.coverType ==  coverType.descriptor) {
				matchingResponse = qr ;
				return true;
			}
		});

		return matchingResponse;
	}

	function transformNewQuote(quotePermutations, quoteRequest) {
		var nr = quotePermutations.coverTypes.length * quotePermutations.paymentFrequencies.length;
		var quotes = Util.arrayFill(nr, quoteRequest).map(function(quote, index) {
			var coverType = quotePermutations.coverTypes[index % quotePermutations.coverTypes.length];
			var paymentFrequency = quotePermutations.paymentFrequencies[index % quotePermutations.paymentFrequencies.length];
			var quoteType = quotePermutations.quoteType ;
			var q = Util.deepClone(quote) ;
			q = Object.extend(q,{
				quoteType: quoteType,
				paymentFrequency: paymentFrequency,
			}) ;

			q = coverTypeTransformer.transform(q, coverType.descriptor);
			q = publicIDTransformer.transform(q) ;
			return q ;
		}) ;

		return quotes ;
	}

	return {
		transform: transform
	}
}
